import ServicePageTemplate from "@/components/layout/ServicePageTemplate";

export default function ConstructionPage() {
  return (
    <div data-testid="construction-page">
      <ServicePageTemplate
        overline="General Construction"
        title="Complete construction support for residential and commercial."
        sub="Framing, structural work, exterior improvements and property upgrades — handled professionally from first day to final inspection."
        image="https://images.pexels.com/photos/8482551/pexels-photo-8482551.jpeg"
        serviceTitle="General Construction"
        services={[
          "Framing",
          "Structural Work",
          "Exterior Improvements",
          "Concrete Work",
          "Roofing Coordination",
          "Property Upgrades",
          "Commercial Improvements",
        ]}
        benefits={[
          "Single Accountable Crew",
          "Clean Daily Site",
          "Detailed Estimates",
          "Quality Materials",
          "Reliable Scheduling",
          "Residential & Commercial",
        ]}
        faq={[
          { q: "Do you handle structural projects?", a: "Yes — we coordinate with engineers as needed and execute structural work to plan." },
          { q: "Can you manage subcontractors?", a: "Absolutely. We act as your general contractor and coordinate the trades on your behalf." },
        ]}
      />
    </div>
  );
}
